"use strict";

import angular from "angular";

import template from "./navbar-tabs.component.html";
import "./navbar-tabs.component.scss";
class NavbarTabsComponent {
    constructor() {}

    $onInit() {}
}

NavbarTabsComponent.$inject = [];

const component = {
    controller: NavbarTabsComponent,
    bindings: {},
    transclude: {
        navbarTabsItem: "?navbarTabsItem"
    }
};

const name = "navbarTabsComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
